import { useMemo, useCallback } from "react";

import { useMemoizedKeyMap } from "@bridgesplit/ui";
import { bpsToUiDecimals } from "@bridgesplit/utils";
import { ExternalYieldVault } from "@bridgesplit/abf-sdk";

import { useExternalYieldInfoQuery, usePausedExternalYieldSourcesQuery } from "../reducers";

export function useExternalYieldVaults() {
    const { data: rawData, ...query } = useExternalYieldInfoQuery();

    const data = useMemo(() => {
        if (!rawData) return undefined;
        return rawData.map((vault) => ({
            ...vault,
            apy: bpsToUiDecimals(vault.apy)
        }));
    }, [rawData]);

    const getKey = useCallback((v: ExternalYieldVault) => v.principalMint, []);
    const principalMintToYieldVault = useMemoizedKeyMap(data, getKey);

    const getYieldVault = useCallback(
        (principalMint: string | undefined) => {
            if (!principalMint || !principalMintToYieldVault) return undefined;
            return principalMintToYieldVault.get(principalMint) ?? null;
        },
        [principalMintToYieldVault]
    );

    return { data, ...query, getYieldVault };
}

export function usePausedExternalYieldSources() {
    const { data, isLoading } = usePausedExternalYieldSourcesQuery();
    return { pausedExternalYieldSources: data, isLoading };
}
